import { api } from "./api";

const salesratemainApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSalesRates: builder.query({
      query: () => "/salesRate",
      providesTags: ["salesRate"],
    }),
    addSalesRate: builder.mutation({
      query: (newSalesRate) => ({
        url: "/salesRate",
        method: "POST",
        body: newSalesRate,
      }),
      invalidatesTags: ["salesRate"],
    }),
    removeSalesRate: builder.mutation({
      query: (id) => ({
        url: `/salesRate/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["salesRate"],
    }),
    editSalesRate: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/salesRate/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["salesRate"],
    }),
  }),
});

export const {
  useGetSalesRatesQuery,
  useAddSalesRateMutation,
  useRemoveSalesRateMutation,
  useEditSalesRateMutation,
} = salesratemainApi;
